import axiosInstance from "../axiosInterceptor";

/* * @param {Object} data - The review rating data to be created.
 * @param {string} data.guideId - The ID of the mentor being reviewed.
 * @param {number} data.rating - The rating given by the user (0-5).
 * @param {string} data.review - The review text provided by the user.
 * @returns {Promise<Object>} - A promise that resolves to the created review rating object.
 */
export const createGuideReviewRating = async (data) => {
  try {
    const response = await axiosInstance.post("/users/review-ratings", data);
    return response.data;
  } catch (error) {
    console.error("Error creating review rating:", error);
    throw error;
  }
};

export const createSessionReviewRating = async (data) => {
  try {
    const response = await axiosInstance.post("/users/session-reviews", data);
    return response.data;
  } catch (error) {
    console.error("Error creating review rating:", error);
    throw error;
  }
};
